/**
 * Configuration des outils de debug et logging
 */

export const DEBUG_CONFIG = {
  // Activer les outils de debug en développement
  ENABLE_DEBUG_TOOLS: import.meta.env.DEV,
  
  // Activer le viewer de logs
  ENABLE_LOG_VIEWER: import.meta.env.DEV,
  
  // Activer les tests de logging
  ENABLE_LOGGING_TESTS: import.meta.env.DEV,
  
  // Activer le monitoring de performance
  ENABLE_PERFORMANCE_MONITOR: import.meta.env.DEV,
  
  // Niveau de log minimum en production
  PRODUCTION_LOG_LEVEL: 'WARN',
  
  // Niveau de log minimum en développement
  DEVELOPMENT_LOG_LEVEL: 'DEBUG',
  
  // Activer la sanitisation des données sensibles
  ENABLE_DATA_SANITIZATION: true,
  
  // Durée de rétention des logs en mémoire (en millisecondes)
  LOG_RETENTION_TIME: 5 * 60 * 1000, // 5 minutes
  
  // Nombre maximum de logs à garder en mémoire
  MAX_LOGS_IN_MEMORY: 100,
  
  // Activer l'envoi automatique des erreurs en production
  ENABLE_ERROR_REPORTING: !import.meta.env.DEV,
  
  // URL pour l'envoi des erreurs (à configurer selon votre service)
  ERROR_REPORTING_URL: import.meta.env.VITE_ERROR_REPORTING_URL || null,
};